import { parseCookies } from '@cian/utils/lib/shared/cookie';
import { selectUserId } from '../../../../shared/selectors/user';
import { getAnalyticsSiteType } from '../../../../shared/utils';
import app from '../app';

const getViewportHeight = () => Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
const getViewportWidth = () => Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

const disabledShowItems = [];
const disabledLoadItems = [];

app.directive('cianAfObserveElement', [
  'config',
  'store',
  (config, store) => ({
    link($scope, element, attr) {
      const el = element[0];

      if (typeof window === 'undefined' || !('IntersectionObserver' in window) || !el) {
        return;
      }

      const intersectionRatioThreshold = 0.5;
      const intersectionViewTimeThreshold = 1000;
      const rootMargin = '0px';
      const root = null;
      const soprApi = config.get('soprApi.browserUrl');

      let isVisible = false;
      let isViewed = false;
      let refreshIntervalID = null;

      function sendTeaserEvent(isTeaserShow) {
        if (attr.trackOnce) {
          if (isTeaserShow === 0) {
            if (disabledLoadItems.includes(attr.demandLocation)) {
              return;
            } else {
              disabledLoadItems.push(attr.demandLocation);
            }
          } else if (isTeaserShow === 1) {
            if (disabledShowItems.includes(attr.demandLocation)) {
              return;
            } else {
              disabledShowItems.push(attr.demandLocation);
            }
          }
        }

        const state = store.getState();
        const userId = selectUserId(state);

        const { deviceType } = config.get('adaptiveSettings') || {};

        const viewport = {
          width: getViewportWidth(),
          height: getViewportHeight(),
        };
        const cid = parseCookies(document.cookie)['_CIAN_GK'];
        const siteType = getAnalyticsSiteType(deviceType);

        fetch(`${soprApi}/teaser/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            user_id: userId,
            device_type: siteType,
            viewport,
            ab_group: 0, // С ab-use смысла в abGroup нет
            cid,
            pageType: 'AddForm',
            items: [
              {
                position: 1,
                isTeaserShow,
                block_type: 'demand',
                demand_location: attr.demandLocation,
              },
            ],
          }),
        });
      }

      function updateAdTimer(element) {
        const lastStarted = element.dataset.lastViewStarted;
        const currentTime = performance.now();
        if (lastStarted) {
          const diff = currentTime - Number(lastStarted);
          element.dataset.totalViewTime = String(Number(element.dataset.totalViewTime) + diff);
        }
        element.dataset.lastViewStarted = String(currentTime);
      }

      function removeVisibleElement() {
        isVisible = false;
        if (refreshIntervalID !== null) {
          window.clearInterval(refreshIntervalID);
          refreshIntervalID = null;
        }
      }

      function moveElementToViewed() {
        if (!isViewed) {
          isViewed = true;
          sendTeaserEvent(1);
        }
        removeVisibleElement();
      }

      function checkVisibleElement(element) {
        if (isVisible) {
          if (Number(element.dataset.totalViewTime) >= intersectionViewTimeThreshold) {
            moveElementToViewed(element);
          }
        }
      }

      function handleRefreshInterval() {
        updateAdTimer(el);
        checkVisibleElement(el);
      }

      function addVisibleElement({ time, target }) {
        target.dataset.lastViewStarted = String(time);
        target.dataset.totalViewTime = '0';

        isVisible = true;
        if (refreshIntervalID === null) {
          window.setInterval(handleRefreshInterval, intersectionViewTimeThreshold);
        }
      }

      function intersectionCallback(elements) {
        elements.forEach(element => {
          if (element.isIntersecting && element.intersectionRatio >= intersectionRatioThreshold) {
            addVisibleElement(element);
          } else {
            if (Number(element.target.dataset.totalViewTime) >= intersectionViewTimeThreshold) {
              checkVisibleElement(element.target);
            } else {
              removeVisibleElement(element.target);
            }
          }
        });
      }

      const observer = new IntersectionObserver(intersectionCallback, {
        root,
        rootMargin,
        threshold: [0, intersectionRatioThreshold],
      });

      observer.observe(el);
      sendTeaserEvent(0);

      $scope.$on('$destroy', () => {
        observer.unobserve(el);
        isViewed = false;
        removeVisibleElement();
      });
    },
  }),
]);
